import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';

const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

const values = [
  {
    icon: 'ri-vip-diamond-line',
    title: 'Kalite',
    desc: 'Her parçada en yüksek standartları benimseyerek, uzun ömürlü ve değerli takılar üretiyoruz.',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'Kişiselleştirme',
    desc: 'Her tasarım, sahibinin hikayesini, duygularını ve tarzını yansıtacak şekilde özenle hazırlanır.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Güven',
    desc: 'Şeffaf süreç, net iletişim ve müşteri memnuniyeti odaklı hizmet anlayışıyla çalışıyoruz.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Yaratıcılık',
    desc: 'Geleneksel işçiliği modern tasarım anlayışıyla birleştirerek eşsiz parçalar ortaya çıkarıyoruz.',
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = 'Hakkımızda – Sara Kuyumculuk';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-luxury-black min-h-screen overflow-x-hidden">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4 font-sans">
            Sara Kuyumculuk
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-white leading-tight mb-6">
            Hakkımızda
          </h1>
          <p className="text-white/50 text-base md:text-lg max-w-2xl mx-auto leading-relaxed font-sans">
            Altın ve mücevherde zarafetin son noktası. Kişiye özel tasarımlarla,
            her parçayı bir hikayeye dönüştürüyoruz.
          </p>
        </div>
      </section>

      {/* Brand Story */}
      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="order-2 lg:order-1">
              <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4 font-sans">
                Marka Hikayemiz
              </p>
              <h2 className="font-serif text-3xl md:text-4xl text-white leading-tight mb-6">
                Her Takı, Bir Hikaye
              </h2>
              <div className="space-y-4 text-white/60 text-sm md:text-base leading-relaxed font-sans">
                <p>
                  SARA KUYUMCULUK, kişiye özel altın ve gümüş tasarımlar üreten
                  bir lüks mücevher markasıdır. Hazır takıların sıradanlığına
                  inanmıyoruz; çünkü her insan eşsizdir ve takıları da öyle
                  olmalıdır.
                </p>
                <p>
                  Yılların verdiği tecrübe ve modern tasarım anlayışını
                  birleştirerek, her parçayı sahibinin tarzına, duygularına ve
                  hikayesine uygun şekilde tasarlıyoruz. İsim kolyelerden özel
                  yüzüklere, anlamlı bilekliklerden unutulmaz hediyelere kadar
                  geniş bir yelpazede hizmet sunuyoruz.
                </p>
                <p>
                  Amacımız sadece takı üretmek değil, her parçayla bir anı,
                  bir duygu, bir bağ yaratmak. Çünkü en değerli mücevher,
                  taşıdığı anlamdır.
                </p>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative">
                <div className="aspect-[4/5] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=elegant%20gold%20jewelry%20craftsmanship%20workshop%20close-up%20artisan%20hands%20working%20on%20delicate%20gold%20necklace%20warm%20soft%20lighting%20luxury%20atmosphere%20minimal%20background%20professional%20photography&width=800&height=1000&seq=about1&orientation=portrait"
                    alt="Sara Kuyumculuk Atölye"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-gold/30 rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24 px-6 md:px-12 bg-luxury-surface">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4 font-sans">
              Değerlerimiz
            </p>
            <h2 className="font-serif text-3xl md:text-4xl text-white">
              Bizi Biz Yapanlar
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((v) => (
              <div
                key={v.title}
                className="text-center p-6 md:p-8 border border-luxury-border rounded-lg hover:border-gold/40 transition-colors duration-500"
              >
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-5">
                  <i className={`${v.icon} text-gold text-2xl`} />
                </div>
                <h3 className="font-serif text-lg text-white mb-3">{v.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed font-sans">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Detail */}
      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4 font-sans">
              Sürecimiz
            </p>
            <h2 className="font-serif text-3xl md:text-4xl text-white">
              Nasıl Çalışıyoruz?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {[
              {
                step: '01',
                title: 'Hayalini Anlat',
                desc: 'WhatsApp üzerinden bize ulaşın. Nasıl bir tasarım istediğinizi, hangi metalde (altın/gümüş), hangi boyutta ve hangi detaylarda olduğunu anlatın. Referans görseller de paylaşabilirsiniz.',
              },
              {
                step: '02',
                title: 'Tasarımı Hazırlayalım',
                desc: 'Usta tasarımcılarımız isteğinizi dinleyerek özel bir tasarım hazırlar. Taslağı size gönderir, beğenmediğiniz noktaları revize ederiz. Onay almadan üretime başlamayız.',
              },
              {
                step: '03',
                title: 'Özel Üretim',
                desc: 'Onaylanan tasarım, en kaliteli malzemelerle ve özenli işçilikle üretilir. Her aşamada kalite kontrolü yapılır. Tamamlanan parça özel kutusunda size ulaştırılır.',
              },
            ].map((item) => (
              <div key={item.step} className="relative">
                <span className="font-serif text-5xl md:text-6xl text-gold/20 absolute -top-4 left-0">
                  {item.step}
                </span>
                <div className="pt-12">
                  <h3 className="font-serif text-xl text-white mb-4">{item.title}</h3>
                  <p className="text-white/50 text-sm leading-relaxed font-sans">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 px-6 md:px-12 bg-luxury-surface">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight mb-6">
            Kendine Özel Bir Tasarıma Hazır Mısın?
          </h2>
          <p className="text-white/50 text-base md:text-lg mb-10 font-sans">
            Hayalindeki takıyı birlikte tasarlayalım. WhatsApp üzerinden hemen
            iletişime geç.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="btn-gold inline-block px-10 py-4 text-sm rounded-sm whitespace-nowrap"
          >
            WhatsApp&apos;tan Yaz
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-luxury-black border-t border-luxury-border py-12 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/1dc01291-9518-472c-8814-2fd5a6290899.png"
                alt="Sara Kuyumculuk"
                className="h-8 w-auto object-contain mb-4"
              />
              <p className="text-white/40 text-sm font-sans leading-relaxed">
                Kişiye özel altın ve gümüş tasarımlar. Her parça, bir hikaye.
              </p>
            </div>
            <div>
              <h4 className="text-white text-sm font-sans mb-4 tracking-wide">
                Sayfalar
              </h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  Ana Sayfa
                </Link>
                <Link
                  to="/hakkimizda"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  Hakkımızda
                </Link>
                <Link
                  to="/sss"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  Sıkça Sorulan Sorular
                </Link>
              </div>
            </div>
            <div>
              <h4 className="text-white text-sm font-sans mb-4 tracking-wide">
                İletişim
              </h4>
              <div className="flex flex-col gap-2">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  WhatsApp: +90 530 171 4669
                </a>
                <span className="text-white/40 text-sm">
                  Türkiye
                </span>
              </div>
            </div>
            <div>
              <h4 className="text-white text-sm font-sans mb-4 tracking-wide">
                Sosyal Medya
              </h4>
              <div className="flex flex-col gap-2">
                <a
                  href="https://www.instagram.com/sara.kuyumculuk"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-white/40 hover:text-gold text-sm transition-colors inline-flex items-center gap-2"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line" />
                  </span>
                  Instagram
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-luxury-border pt-6 text-center">
            <p className="text-white/30 text-xs font-sans">
              &copy; {new Date().getFullYear()} Sara Kuyumculuk. Tüm hakları saklıdır.
            </p>
          </div>
        </div>
      </footer>

      <FloatingWhatsApp />
    </main>
  );
}